import { FC } from "react";
import { Flex } from "@chakra-ui/react";
import { PersonalizedExperienceStep } from "./PersonalizedExperienceStep";
import { TryItOutStep } from "./TryItOutStep";
import { WhatYouNeedStep } from "./WhatYouNeedStep";

export const Steps: FC = () => {
  return (
    <Flex align="center" direction="column" gap={{ base: 4, md: 6 }}>
      <WhatYouNeedStep />
      <PersonalizedExperienceStep />
      <TryItOutStep />
    </Flex>
  );
};
